import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ad32c2c0")

_pushScopeId("data-v-ad32c2c0")
const _hoisted_1 = { class: "panel-container" }
const _hoisted_2 = { class: "display-flex" }
const _hoisted_3 = { style: {"flex":"1"} }
const _hoisted_4 = { class: "scroll" }
const _hoisted_5 = {
  key: 1,
  class: "text-align-center block-title"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_f7_link = _resolveComponent("f7-link")
  const _component_f7_searchbar = _resolveComponent("f7-searchbar")
  const _component_f7_button = _resolveComponent("f7-button")
  const _component_f7_list_item = _resolveComponent("f7-list-item")
  const _component_f7_list = _resolveComponent("f7-list")
  const _component_f7_page = _resolveComponent("f7-page")

  return (_openBlock(), _createBlock(_component_f7_page, null, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_f7_link, {
            class: "menu-btn",
            "icon-only": "",
            "icon-f7": "menu",
            "icon-size": "32",
            "panel-open": "left"
          }),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_f7_searchbar, {
              id: "panel-search",
              "disable-button-text": "Cancel",
              placeholder: "Search by name or ID",
              "clear-button": false,
              "disable-button": false,
              "custom-search": "",
              value: _ctx.searchQuery,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchQuery = $event))
            }, null, 8, ["value"])
          ])
        ]),
        (_ctx.searchQuery.length > 0)
          ? (_openBlock(), _createBlock(_component_f7_button, {
              key: 0,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearSearch())),
              text: "Clear search"
            }))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_f7_list, {
            class: "programs-list searchbar-found no-margin",
            "no-hairlines": ""
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.results, (result) => {
                return (_openBlock(), _createBlock(_component_f7_list_item, {
                  title: result.title,
                  footer: result.subtitle,
                  key: result.id,
                  link: result.link,
                  style: 
              result.id == _ctx.appState.activeBuilder
                ? 'background-color: #303030'
                : null
            ,
                  view: ".view-main"
                }, null, 8, ["title", "footer", "link", "style"]))
              }), 128))
            ]),
            _: 1
          }),
          (_ctx.fetching)
            ? (_openBlock(), _createBlock(_component_f7_list, {
                key: 0,
                "no-hairlines": "",
                class: "skeleton-text skeleton-effect-wave no-margin"
              }, {
                default: _withId(() => [
                  _createVNode(_component_f7_list_item, {
                    title: "Title and beans",
                    footer: "Footer"
                  }),
                  _createVNode(_component_f7_list_item, {
                    title: "Title and even mOrE bEans",
                    footer: "Foooooooooooter"
                  }),
                  _createVNode(_component_f7_list_item, {
                    title: "Title and more beans",
                    footer: "Footer"
                  }),
                  _createVNode(_component_f7_list_item, {
                    title: "Title and no beans",
                    footer: "Footooer"
                  })
                ]),
                _: 1
              }))
            : (_ctx.results.length == 0)
              ? (_openBlock(), _createBlock("p", _hoisted_5, " Nothing found. "))
              : _createCommentVNode("", true)
        ]),
        _createVNode(_component_f7_button, {
          fill: "",
          text: "New Builder",
          href: "/builders/new",
          style: {"margin":"20px"}
        })
      ])
    ]),
    _: 1
  }))
})